import React from 'react';

function App() {
  return (
      <div style={{ textAlign: 'center', padding: '50px' }}>
        <h1>Welcome to Scilef Experiments Bot!</h1>
        <p>This is a prototype of a game-building experiment where players decide the future of the game.</p>
        <a href="https://t.me/scilef_games">Subscribe to our channel</a>
      </div>
  );
}

export default App;
